import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Entry } from 'contentful';
import { NdcHelpdeskFaqPage } from 'src/app/model/page/group/faq/ndc-helpdesk-faq-page';
import { ContentfulService } from 'src/app/service/contentful.service';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';

@Component({
  selector: 'app-ndc-helpdesk-faq-page',
  templateUrl: './ndc-helpdesk-faq-page.component.html',
  styleUrls: ['./ndc-helpdesk-faq-page.component.scss']
})
export class NdcHelpdeskFaqPageComponent implements OnInit {
  param: number = -1;
  ndcHelpdeskFaqPage: NdcHelpdeskFaqPage = {} as NdcHelpdeskFaqPage;
  BackLinkTitle: string = '';
  BackLinkURL: string = '';
  BackLinkIcon: string = '';

  constructor(private activatedRoute: ActivatedRoute, private contentfulService: ContentfulService) {}

  ngOnInit(): void {
    htmlTitle.filter((title) => {
      if (title.page === 'faq-support') {
        this.ndcHelpdeskFaqPage.htmlTitle = title.htmlTitle;
      }
    });
    this.activatedRoute.params.subscribe((params) => (this.param = params['param']));
    this.ndcHelpdeskFaqPage.sections = [];
    const query = { 'fields.title': 'NDC Support FAQ' };
    this.contentfulService.getPageContentWithEntries(query).then((ndcHelpdeskFaqPageEntries) => {
      this.mapBanner(ndcHelpdeskFaqPageEntries);
      this.mapSections(ndcHelpdeskFaqPageEntries);
    });
    this.contentfulService.getPageContentWithItems(query).then((linkItems) => {
      this.BackLinkTitle = linkItems[0]?.fields.constants[0].BackLinkTitle;
      this.BackLinkURL = linkItems[0]?.fields.constants[0].BackLinkURL;
      this.BackLinkIcon = linkItems[0]?.fields.constants[0].BackLinkIcon;
      this.ndcHelpdeskFaqPage.htmlTitle = linkItems[0].fields.htmlTitle;
    });
  }
  private mapBanner(ndcHelpdeskFaqPageEntries: Entry<any>[]) {
    ndcHelpdeskFaqPageEntries
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapEntryToBanner(entry: Entry<any>) {
    let image: any = entry.fields['image'] as string;
    this.ndcHelpdeskFaqPage.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: image.fields.file.url
    };
  }
  private mapSections(ndcHelpdeskFaqPageEntries: Entry<any>[]) {
    ndcHelpdeskFaqPageEntries
      .filter((entry) => ModelValidator.isSection(entry))
      .forEach((entry) => {
        this.mapEntryToSection(entry);
      });

    this.ndcHelpdeskFaqPage.sections.sort((a, b) => a.order - b.order);
  }

  private mapEntryToSection(entry: Entry<any>) {
    let givenTitle: any = entry.fields['title'] as string;
    let pageTitle = givenTitle.split('#')[1];

    this.ndcHelpdeskFaqPage.sections.push({
      title: pageTitle,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number
    });
  }
}
